import { $isWalletConnected, $userAddress } from '@brickken/web3';
import { useEffect, useState } from 'react';

export type UseWalletReturnType = {
  isWalletConnected: boolean;
  userAddress: string;
};
export const useWallet = (): UseWalletReturnType => {
  const [isWalletConnected, setIsWalletConnected] = useState<boolean>(
    $isWalletConnected?.value
  );
  const [userAddress, setUserAddress] = useState<string>($userAddress?.value);
  useEffect(() => {
    const isWalletConnectedSubscription = $isWalletConnected?.subscribe(
      (connected: boolean) => {
        setIsWalletConnected(connected);
      }
    );
    const userAddressSubscription = $userAddress?.subscribe((address) => {
      setUserAddress(address);
    });
    return () => {
      isWalletConnectedSubscription?.unsubscribe();
      userAddressSubscription?.unsubscribe();
    };
  }, []);
  return {
    isWalletConnected,
    userAddress
  };
};
